import LoadTimeline from '../base/load-timeline';
import Action from "../base/action";

class TextInput extends Action {
    inputVariable;
    loadTimelines;
    cancelTimelines;

    constructor(props) {
        super(props);
        this.inputVariable = props.inputVariable || "";
        this.loadTimelines = props.loadTimelines || {timelines: [], prune: {}};
        this.cancelTimelines = props.cancelTimelines || {timelines: [], prune: {}};
    }

    async execute(eventLoop) {
        let self = this;
        let keyboardCallbacks = {};

        const enterCallback = (text) => {
            if (!text.trim().length) {
                VRMessageController.addMessage({text: 'Can not input empty value for a variable', priority: VrMessagePriorityEnum.HIGHPRIORITYINFO});
                keyboardController.changeTextFieldVisibility(false);
                keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks);
                return;
            }

            eventLoop.training.registry.set(self.inputVariable, text);
            if (self.loadTimelines.timelines.length > 0) {
                const loadTimeline = new LoadTimeline({timelines: self.loadTimelines.timelines, prune: self.loadTimelines.prune});
                loadTimeline.execute(eventLoop);
            }
        };

        const cancelCallback =  () => {
            if (self.cancelTimelines.timelines.length > 0) {
                const loadTimeline = new LoadTimeline({timelines: self.cancelTimelines.timelines, prune: self.cancelTimelines.prune});
                loadTimeline.execute(eventLoop);
            }
        };

        keyboardCallbacks.enterCallback = enterCallback;
        keyboardCallbacks.cancelCallback = cancelCallback;
        keyboardController.toggleState(keyboardController.getVRKeyboardParent(), keyboardCallbacks);
    }
}

export default TextInput;